import { render, staticRenderFns } from "./DynamicDataDialog.vue?vue&type=template&id=844bd956&"
import script from "./DynamicDataDialog.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDataDialog.vue?vue&type=style&index=0&id=844bd956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports